/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S16_BodyInputs */

const tr_kullanim_s16_body = /** @type {(inputs: Kullanim_S16_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandemi, savaş, doğal afet, altyapı kesintisi, internet servis sağlayıcı arızası, siber saldırı, yasal düzenleme değişikliği ve benzeri tarafların kontrolü dışındaki olaylarda tarafların sorumlulukları askıya alınır. Mücbir sebebin 60 günü aşması halinde taraflar Sözleşme'yi tek taraflı feshedebilir.`)
};

const en_kullanim_s16_body = /** @type {(inputs: Kullanim_S16_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the event of a pandemic, war, natural disaster, infrastructure outage, internet service provider failure, cyber attack, change of legal regulation and similar events outside the parties' control, the parties' obligations are suspended. If the force majeure exceeds 60 days, the parties may terminate the Agreement unilaterally.`)
};

const de_kullanim_s16_body = /** @type {(inputs: Kullanim_S16_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Pandemie, Krieg, Naturkatastrophe, Infrastrukturausfall, Störung des Internetdienstanbieters, Cyberangriff, Änderung gesetzlicher Regelungen und ähnlichen außerhalb der Kontrolle der Parteien liegenden Ereignissen werden die Pflichten der Parteien ausgesetzt. Dauert die höhere Gewalt länger als 60 Tage, können die Parteien den Vertrag einseitig kündigen.`)
};

const ru_kullanim_s16_body = /** @type {(inputs: Kullanim_S16_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При пандемии, войне, стихийном бедствии, сбое инфраструктуры, аварии интернет-провайдера, кибератаке, изменении правового регулирования и подобных событиях вне контроля сторон обязанности сторон приостанавливаются. Если форс-мажор длится более 60 дней, стороны могут расторгнуть Договор в одностороннем порядке.`)
};

/**
* | output |
* | --- |
* | "In the event of a pandemic, war, natural disaster, infrastructure outage, internet service provider failure, cyber attack, change of legal regulation and sim..." |
*
* @param {Kullanim_S16_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s16_body = /** @type {((inputs?: Kullanim_S16_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S16_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s16_body(inputs)
	if (locale === "de") return de_kullanim_s16_body(inputs)
	if (locale === "ru") return ru_kullanim_s16_body(inputs)
	return tr_kullanim_s16_body(inputs)
});